import { Button, Empty, Flex, Typography } from 'antd'
import { useMemo, useState } from 'react'

import type { Invitee, School, SchoolUser } from '../../../../../types'

import { InviteeTable } from './InviteeTable'
import { InviteSchoolUserModal } from './InviteSchoolUserModal'

export const InvitedTab = ({
    fetch,
    invitees,
    school
}: {
    fetch: () => Promise<void>
    school: School
    invitees: Invitee[]
}) => {
    const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false)

    const closeAddUserModal = () => {
        setIsAddUserModalOpen(false)
    }

    const existingEmails = useMemo(() => {
        return school.schoolUsers.map((su: SchoolUser) => su.user.email)
    }, [school.schoolUsers])

    return (
        <>
            <Flex justify="space-between" align="center">
                <Typography.Title level={4}>Invited</Typography.Title>
                <Button type="primary" onClick={() => setIsAddUserModalOpen(true)}>
                    + Invite
                </Button>
            </Flex>
            {!invitees && <Empty />}
            {invitees && <InviteeTable schoolId={school.id} invitees={invitees} refetch={fetch} />}

            {isAddUserModalOpen && (
                <InviteSchoolUserModal
                    key={isAddUserModalOpen.toString()}
                    isOpen={isAddUserModalOpen}
                    school={school}
                    onClose={closeAddUserModal}
                    refetch={fetch}
                    existingEmails={existingEmails}
                    availableSchoolSubscriptions={school.schoolSubscriptions}
                />
            )}
        </>
    )
}
